<style lang="less">
@import "../../../../styles/public/public.less";
@import "../less/district_district.less";

.research_total_select {
  margin-top: -80px;
}

.research_total_content {
  padding: 0px 8px;
  width: 100%;
  margin-top: 2%;

  border-radius: 15px;

  .research_total_year {
    width: 100%;
    margin-top: 4px;
  }

  .research_total_num {
    width: 100%;
    text-align: center;
  }

  .research_countfunds {
    text-align: center;
    background: url("../../../../../static/images/yhtjbj.png");
    background-size: 100% 100%;
    padding: 8px 0px;
    width: 55px;
  }
  .research_countfunds_child {
    height: 40px;
  }
}
</style>
<template>
  <div class="district_district">
    <div class="district_district1 display_column">
      <div class="district_district_top dispaly_flex00 media_w_w18 display_row_js_ac">
        <div class="display_row_ac">
          <div class="district_district_top_1"></div>
          <span>科研总量与经费</span>
        </div>

        <div class="research_total_select">
          <Select v-model="model1" style="width:85px;" size="small" @on-change="getData">
            <Option v-for="item in yearList" :value="item.PROYEAR">{{ item.PROYEAR }}</Option>
          </Select>
        </div>
      </div>
      <div class="district_district_bottom dispaly_flex11">
        <div class="research_total_content dispaly_flex00">
          <div class="display_row_js_ac">
            <div v-for="item in fundlist" class="research_countfunds">
              <div class="media_w_w22 research_countfunds_child">{{item.NUM}}</div>
              <div class="media_w_w14">{{item.TYPENAME}}</div>
            </div>
            <!-- <div class="research_countfunds ">
                        <div class="media_w_w24 research_countfunds_child">{{funds}}</div>
                        <div class="media_w_w18">总经费</div>
                    </div>
                    <div class="research_countfunds ">
                        <div class="media_w_w24 research_countfunds_child">{{proclass}}</div>
                        <div class="media_w_w18">计划类</div>
                    </div>
                    <div class="research_countfunds ">
                        <div class="media_w_w24 research_countfunds_child">{{guideclass}}</div>
                        <div class="media_w_w18">指导类</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../../../app/event";
export default {
  components: {},
  data() {
    return {
      fundlist: [],
      cityList: [],
      yearList: [],
      model1: ""
    };
  },
  methods: {
    // initYearData() {
    //     let date = new Date();
    //     let year = date.getFullYear()+1;
    //     this.model1=year-1;
    //     for (let i = 0; i < 5; i++) {
    //         let yearmodel = {};
    //         yearmodel.label = year - i + "年";
    //         yearmodel.value = year - i;
    //         this.yearList.push(yearmodel);
    //     }
    //     this.getData();
    // },
    //获取年份
    getYear() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=generalsql",
          {
            FILED: "PROYEAR",
            TABLENAME: "PRO_INFO",
            SQLWHERE: "1=1 group by PROYEAR"
          }
        )
        .then(res => {
          if (res.status == 200) {
            _this.yearList = res.data;
            this.model1 = _this.yearList[0].PROYEAR;
            _this.getData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    getData: function() {
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=listcount",
          {
            Year: this.model1
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.statuslist = [];
            if (res.data.length == 0) {
              this.$Message.info("暂无数据");
              return;
            }
            this.fundlist = res.data.allnum;
            bus.$emit("scitype", res.data.allnum);
            bus.$emit("scistatue", res.data.allstep);
            bus.$emit("proAlert", res.data.diffdata);
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    }
  },
  mounted() {
    // this.initYearData();
    this.getYear();
  },
  directives: {}
};
</script>



// WEBPACK FOOTER //
// research_total.vue?49c88551